exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".textContact {\r\n  text-align: center;\r\n  font-size: 1.1rem;\r\n  color: white;\r\n  line-height: 1.6;\r\n  padding: 2% 0%;\r\n}\r\n\r\n.backgroundBlack{\r\n  background-color: black;\r\n}\r\n\r\n@media only screen and (max-width: 900px) {\r\n  .textContact{\r\n    font-size: 1rem;\r\n  }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/gdb/Documents/work/garrido-angular/garrido-front/src/app/footer/footer.component.css
// module id = ../../../../../src/app/footer/footer.component.css
// module chunks = main